// src/mocks/handlers/funding/activityCashMovementsDownloadPdfHandler.ts

import { rest } from 'msw';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import { ICashMovementsPdfResponse } from '@/domains/funding/activity.types';
import { isAccessTokenExpired } from '@/mocks/lib/authTokenUtils';
// import cashMovementsPdfData from '@/mocks/data/cashMovementsPdfData.json';

export const cashMovementsDownloadPdfHandler =
  rest.get<ICashMovementsPdfResponse>(
    `${VITE_MSW_BASE_URL}${API_ENDPOINTS.FUNDING_ACTIVITY_CASH_MOVEMENTS_DOWNLOAD_PDF}`,
    (req, res, ctx) => {
      const token = req.headers.get('Authorization');
      if (!token) {
        return res(
          ctx.status(500),
          ctx.json({ detail: 'Something went wrong' }),
        );
      }

      if (isAccessTokenExpired()) {
        return res(
          ctx.status(401),
          ctx.json({ error: 'Access token expired' }),
        );
      }

      const { customer_uuid, transaction_uuid } = req.params;
      /* eslint-disable no-console */
      console.log('customer_uuid', customer_uuid);
      console.log('transaction_uuid', transaction_uuid);
      /*
      const pdfRecord = cashMovementsPdfData.find(
      (entry) =>
      entry.customer_uuid === customer_uuid &&
      entry.transaction_uuid === transaction_uuid,
      );

      if (!pdfRecord) {
      return res(ctx.status(404), ctx.json({ error: 'PDF not found' }));
      }*/

      return res(
        ctx.status(200),
        ctx.json({
          url: 'https://app.notion.com/p/revving/Examples-of-reports-3880b27387aa808d8166cef45ffcdbc1',
        }),
      );
    },
  );
